module.exports = __webpack_public_path__ + "static/img/ap15.a167472.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/ap15.jpg
// module id = Uw5l
// module chunks = 1